import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditCanalVentaTxComponent } from "./edit-canal-venta-tx/edit-canal-venta-tx.component";

@Component({
  selector: "app-canal-venta-tx",
  templateUrl: "./canal-venta-tx.component.html",
  styleUrls: ["./canal-venta-tx.component.scss"],
})
export class CanalVentaTxComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditCanalVentaTxComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
